import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { isPlatformServer } from '@angular/common';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AccountInfoFetchingStatus, AccountType } from '~shared/models';
import { NUMBER_1 } from '~shared/constants';
import { UrlUtil } from '~shared/utils/url.util';

import { IdentityService } from '../modules/identity/services/identity.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeAuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly identityService: IdentityService,
    @Inject(PLATFORM_ID) private readonly platform: Object
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (isPlatformServer(this.platform)) {
      return of(true);
    }

    const checkIsEmployee$ = this.identityService.getAuthAccountInfoStatus().pipe(
      filter((accountInfoFetchingStatus) => accountInfoFetchingStatus !== AccountInfoFetchingStatus.LOADING),
      take(NUMBER_1),
      map((accountInfoFetchingStatus) =>
        [AccountType.EMPLOYEE, AccountType.EMPLOYEE_AS_CUSTOMER].includes(accountInfoFetchingStatus as AccountType)
      ),
      map((isEmployee) => {
        if (isEmployee) {
          return true;
        }
        UrlUtil.redirectToReactHomePage();
        return false;
      })
    );

    return checkIsEmployee$;
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
